import React from 'react';
import Boxcomponents from './Boxcomponents';

function FrameComponents() {

  return (
    <div className="frame">
     <Boxcomponents />
      
    </div>
  );
}

export default FrameComponents;